'use strict';

/**
* Embeds the CSS for the UI into the document head
*/
function _addCSS(document, config) {
    var css = config.css,
        styleEl = document.createElement('style');

    css = css.replace(new RegExp('PPFrame', 'g'), config.name);

    styleEl.type = 'text/css';
    config.bodyStyle = styleEl.id = 'PP--IC--CSS';

    if (styleEl.styleSheet) {
        styleEl.styleSheet.cssText = css;
    } else {
        styleEl.appendChild(document.createTextNode(css));
    }

    config.css = css;
    document.getElementsByTagName('head')[0].appendChild(styleEl);
}

function _removeCSS(document, config) {
    if (config.bodyStyle) {
        var styleEl = document.getElementById(config.bodyStyle);
        if (styleEl) {
            styleEl.parentNode.removeChild(styleEl);
        }
    }
}

module.exports = {
    add: _addCSS,
    remove: _removeCSS
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/css.js
 ** module id = 9
 ** module chunks = 0
 **/